module.exports = __webpack_public_path__ + "static/media/noaffiliate.a162c29a.svg";